import React, { useEffect, useState } from 'react';
import { usePortalT, type PortalLocale } from './i18n/PortalLocaleProvider';
import '../styles/portal.css';

const STORAGE_KEY = 'portal-locale';

function hasStoredLocale(): boolean {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'en' || v === 'kn';
  } catch {
    return false;
  }
}

export function PortalLanguageGate({ children }: { children: React.ReactNode }) {
  const { setLocale } = usePortalT();
  const [ready, setReady] = useState(() => hasStoredLocale());

  useEffect(() => {
    if (hasStoredLocale()) setReady(true);
  }, []);

  if (ready) return <>{children}</>;

  function choose(locale: PortalLocale) {
    setLocale(locale);
    setReady(true);
  }

  return (
    <div className="portal-app min-h-[100dvh] bg-[#f5f6f8] flex flex-col items-center justify-center px-6">
      <div className="w-full max-w-xs text-center">
        {/* Brand */}
        <div className="flex items-center justify-center gap-1.5 mb-8">
          <span className="text-2xl font-bold tracking-tight text-[#0f172a]">
            Mane boar<span className="text-amber-500">D</span>
          </span>
        </div>

        <h1 className="text-lg font-bold text-[#0f172a] mb-1">Choose your language</h1>
        <p className="text-sm text-gray-400 mb-2">ನಿಮ್ಮ ಭಾಷೆ ಆರಿಸಿ</p>
        <p className="text-xs text-gray-400 mb-8">You can change this later in your profile.</p>

        <div className="flex flex-col gap-3">
          <button
            type="button"
            onClick={() => choose('en')}
            className="w-full bg-[#0f172a] text-white font-semibold text-base rounded-none py-4 hover:bg-[#1e293b] transition-colors"
          >
            English
          </button>
          <button
            type="button"
            onClick={() => choose('kn')}
            className="w-full bg-white border-2 border-[#0f172a] text-[#0f172a] font-semibold text-base rounded-none py-4 hover:bg-gray-50 transition-colors"
          >
            ಕನ್ನಡ
          </button>
        </div>
      </div>
    </div>
  );
}
